import * as React from "react";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { SelectFromModalButton } from "src/components/SelectFromModalButton";
import { ZSidLabel, ZUser } from "src/types";

import { loadUsers } from "../apiUsers";
import { SelectUserModal } from "./SelectUserModal";

type PropsSelectUser = {
  multiple?: boolean;
  disabled?: boolean;
  value?: ZSidLabel | ZSidLabel[];
  onChange?(newValue?: ZSidLabel | ZSidLabel[]): void;
};

export const SelectUser: React.FC<PropsSelectUser> = (props) => {
  const { multiple, disabled, value, onChange } = props;
  let options: ZSidLabel[] = [];
  if (value) {
    options = Array.isArray(value) ? value : [value];
  }
  const onChangeLocal = (newValue: ZSidLabel[] | null) => {
    if (multiple) {
      onChange?.(newValue ?? []);
    } else {
      onChange?.(newValue?.[0] ?? undefined);
    }
  };
  const [tableStore, setTableStore] = React.useState<
    RtStore<ZUser, {}> | undefined
  >();

  const createStore = () => {
    const st = new RtStore({
      rowKey: "id",
      loader: loadUsers(),
      selectionType: multiple ? "checkbox" : "radio",
      keepSelected: true,
    });
    st.setSelectedKeys(options.map(({ id }) => id));
    setTableStore(st);
  };

  return (
    <SelectFromModalButton
      disabled={disabled}
      options={options}
      multi={multiple}
      onChange={onChangeLocal}
      onOpen={createStore}
    >
      <SelectUserModal
        tableStore={tableStore}
        srcSelected={options}
        close={() => setTableStore(undefined)}
        onApply={onChangeLocal}
      />
    </SelectFromModalButton>
  );
};
